import { useQuery } from '@tanstack/react-query';
import { api } from '../../libs/axios';
import { Usuario } from '../../utils/interfaces';

type UseUsuarioProps = {
  id?: string;
};

async function getUsuario({ id }: UseUsuarioProps): Promise<Usuario> {
  const response = await api.get(`usuario/${id}`).then((res) => res.data);

  return response.data;
}

export function useUsuario({ id }: UseUsuarioProps) {
  return useQuery({
    queryKey: ['usuario-detalhe', { id }],
    queryFn: () => getUsuario({ id }),
    enabled: !!id,
    retry: false,
    refetchOnWindowFocus: false,
  });
}
